import {
  API_ERROR,
  GET_LOCATIONS,
  LOCATION_LIST_SUCCESSFUL,
  GET_SUB_LOCATIONS,
  SUB_LOCATION_LIST_SUCCESSFUL,
  GET_DEPARTMENT,
  DEPARTMENT_LIST_SUCCESSFUL,
  GET_USERS,
  USERS_LIST_SUCCESS,
  USER_ROW_DATA,
  USER_ROW_DATA_SUCCESS,
  GROUPS_LIST,
  SELECT_CHANGE_DEPT_VALUE,
  GROUPS_LIST_SUCCESS,
  DEPT_SELECT_FILED,
  REMOVE_DEPT_SELECT_FILED,
  GET_HOD_CHECKED,
  LOC_SELECT_FILED,
  REMOVE_LOC_SELECT_FILED,
  SELECT_CHANGE_LOC_VALUE,
  MULTI_SELECT_SUBLOC_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  MULTI_SELECT_CHANGEVALUE,

  //----------
  SET_PARAMS,
  MODEL_OPEN,
  MODEL_CLOSE,
  USER_ADD,
  USER_ADD_SUCCESSFUL,
  USER_EDIT,
  // USER_EDIT_SUCCESSFUL,
  USER_DELETE,
  GROUP_ADD,
  GROUP_ADD_SUCCESSFUL,
  SET_PROFILE_PARAMS,
  UPDATE_GROUPS_LIST,
  SET_PROFILE_PAGINATION_PARAMS,
  PAGINATION_GROUPS_LIST,
  PAGINATION_GROUPS_LIST_SUCCESS,
} from "./actionTypes";

export const getLocations = (id) => {
  return {
    type: GET_LOCATIONS,
    payload: { id },
  };
};
export const locationListSuccessful = (response) => {
  return {
    type: LOCATION_LIST_SUCCESSFUL,
    payload: { response },
  };
};
export const getSubLocations = () => {
  return {
    type: GET_SUB_LOCATIONS,
    // payload: { id },
  };
};
export const sublocationListSuccessful = (response) => {
  return {
    type: SUB_LOCATION_LIST_SUCCESSFUL,
    payload: { response },
  };
};
export const getDepartment = () => {
  return {
    type: GET_DEPARTMENT,
  };
};
export const DepartmentListSuccessful = (response) => {
  return {
    type: DEPARTMENT_LIST_SUCCESSFUL,
    payload: { response },
  };
};

export const getUsers = (data) => {
  return {
    type: GET_USERS,
    payload: { data },
  };
};
export const usersListSuccessful = (response) => {
  return {
    type: USERS_LIST_SUCCESS,
    payload: response,
  };
};
export const getRowUserData = (UserId) => {
  return {
    type: USER_ROW_DATA,
    payload: { UserId },
  };
};
export const UserRowDataSuccessful = (response) => {
  return {
    type: USER_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const getGroupsList = (data) => {
  return {
    type: GROUPS_LIST,
    payload: { data }
  };
};

export const groupsListSuccessful = (response) => {
  return {
    type: GROUPS_LIST_SUCCESS,
    payload: response,
  };
};
export const getPaginationGroupsList = (data) => {
  return {
    type: PAGINATION_GROUPS_LIST,
    payload: { data }
  };
};

export const paginationGroupsListSuccessful = (response) => {
  return {
    type: PAGINATION_GROUPS_LIST_SUCCESS,
    payload: response,
  };
};
export const getDeptSelectFiled = (id) => {
  return {
    type: DEPT_SELECT_FILED,
    payload: { id },
  };
};
export const removeDeptSelectFiled = (id) => {
  return {
    type: REMOVE_DEPT_SELECT_FILED,
    payload: { id },
  };
};
export const getLocSelectFiled = (id) => {
  return {
    type: LOC_SELECT_FILED,
    payload: { id },
  };
};
export const removeLocSelectFiled = (id) => {
  return {
    type: REMOVE_LOC_SELECT_FILED,
    payload: { id },
  };
};
export const SelecteChangeDeptValue = ({ key, label, key2, value, i }) => {
  return {
    type: SELECT_CHANGE_DEPT_VALUE,
    payload: { key, label, key2, value, i },
  };
};
export const SelecteChangeLocValue = ({ key, label, key2, value, i }) => {
  return {
    type: SELECT_CHANGE_LOC_VALUE,
    payload: { key, label, key2, value, i },
  };
};
export const MultiSelecteChangeSubLocValue = (multiValues, i) => {
  return {
    type: MULTI_SELECT_SUBLOC_CHANGEVALUE,
    payload: { multiValues, i },
  };
};
export const getHODChecked = (checked, id, index) => {
  return {
    type: GET_HOD_CHECKED,
    payload: { checked, id, index },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const MultiSelecteChangeValue = (label, multiValues) => {
  return {
    type: MULTI_SELECT_CHANGEVALUE,
    payload: { label, multiValues },
  };
};
export const userAdd = (userdata, Userdata2) => {
  return {
    type: USER_ADD,
    payload: { userdata, Userdata2 },
  };
};
export const userAddSuccessfull = (response) => {
  return {
    type: USER_ADD_SUCCESSFUL,
    payload: response,
  };
};
export const userEdit = (userdata, Userdata2) => {
  return {
    type: USER_EDIT,
    payload: { userdata, Userdata2 },
  };
};
// export const userAddSuccessfull = (response) => {
//   return {
//     type: USER_ADD_SUCCESSFUL,
//     payload: response,
//   };
// };
//-----------------------

// export const getLocations = () => {
//   return {
//     type: GET_LOCATIONS,
//   };
// };
// export const locationListSuccessful = (locations) => {
//   return {
//     type: LOCATION_LIST_SUCCESSFUL,
//     payload: locations,
//   };
// };

export const userDelete = (userId, history) => {
  return {
    type: USER_DELETE,
    payload: { userId, history },
  };
};

export const groupAdd = (groupdata, history) => {
  return {
    type: GROUP_ADD,
    payload: { groupdata, history },
  };
};
export const groupAddSuccessfull = (response) => {
  return {
    type: GROUP_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const SetProfileParams = (params) => {
  return {
    type: SET_PROFILE_PARAMS,
    payload: params,
  };
};
export const SetProfilePaginationParams = (params) => {
  return {
    type: SET_PROFILE_PAGINATION_PARAMS,
    payload: params,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
export const updateGroupsList = (newGroups) => ({
  type: UPDATE_GROUPS_LIST,
  payload: newGroups,
});